import type { AxiosRequestConfig } from 'axios';

export default class ApiRequestError extends Error {
  public message: string;
  public method: AxiosRequestConfig['method'];
  public uri: string;

  public name = 'ApiRequestError';

  constructor({ method, uri }: { method: AxiosRequestConfig['method']; uri: string }) {
    // See https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    super(`${method} ${uri}`);
    Object.setPrototypeOf(this, new.target.prototype);

    this.message = `${method} ${uri}`;
    this.method = method;
    this.uri = uri;
  }
}
